export enum TabLabel {
  Cases = 'Cases',
  Transactions = 'Transactions',
  Payments = 'Payments',
}


export enum TabDataCenterLabel {
  MemberData = 'Member Data',
  ExternalData = 'External Data',
}
